import React, { useEffect, useState, Suspense } from 'react'
import StepWizard from 'react-step-wizard'
import GeneralData from './GeneralData'
import LocationData from './LocationData'
import EvaluationData from './EvaluationData'
import './crearFormulario.scss'
import { Grid } from '@material-ui/core'
import { useForm } from '../../../../context/formContext'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import SaveIcon from '@material-ui/icons/Save'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import DraftForm from '../../../../utils/formDraft'
import { useAuthentication } from '../../../../context/authenticationContext'
import { createForm } from '../../../../services/IFI/create'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { LoadingButton } from '@mui/lab'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { getPreIFIPDF } from '../../../../services/IFI/get'

const CreateForm = () => {
  const {
    step,
    preEligibilityForm,
    setFetchRequest,
    setPreEligibilityForm,
    dollarAmount,
    editLoading,
    checkPYME,
    setCheckPYME,
  } = useForm()
  const { userIDB2C } = useAuthentication()
  const {
    userCompanyID,
    userFullName,
    userCompanyName,
    userCompanyType,
    userCountry,
  } = useAuthentication()
  const history = useHistory()

  useEffect(() => {
    setFetchRequest(['create_form'])
  }, [])

  const [loadingPDF, setLoadingPDF] = useState(false)

  const cancelForm = () => {
    // Swal.fire({
    //   title: '¿Estás seguro?',
    //   text: 'Se perderán los datos no guardados',
    //   icon: 'error',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Entendido',
    //   cancelButtonText: 'Cancelar',
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     setPreEligibilityForm([])
    //     history.push('/')
    //   }
    // })

    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const exit = true
        saveForm(exit)
      } else if (result.isDenied) {
        history.push('/')
        setPreEligibilityForm([])
      }
    })
  }

  const [loadingSave, setLoadingSave] = useState(false)

  const saveForm = (exit) => {
    setLoadingSave(true)
    const draft = DraftForm(
      { ...preEligibilityForm, idUserB2C: userIDB2C },
      preEligibilityForm.companyId &&
        userCompanyID !== preEligibilityForm.companyId
        ? preEligibilityForm.companyId
        : userCompanyID,
      userFullName,
      preEligibilityForm.companyName &&
        userCompanyName !== preEligibilityForm.companyName
        ? preEligibilityForm.companyName
        : userCompanyName,
      preEligibilityForm.companyTypeId &&
        userCompanyType !== preEligibilityForm.companyTypeId
        ? preEligibilityForm.companyTypeId
        : userCompanyType,
      userCountry,
      dollarAmount,
    )
    createForm(draft)
      .then((res) => {
        if (res.Data.OK) {
          setLoadingSave(false)

          const mensaje = `Formulario de Pre-Elegibilidad guardado exitosamente`
          Swal.fire({
            title: `Guardado`,
            text: `${mensaje}`,
            icon: 'success',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Entendido',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          setPreEligibilityForm({
            ...preEligibilityForm,
            idForm: res.Data.IdForm,
          })
          if (exit) {
            history.push('/')
            setPreEligibilityForm([])
          }
        }

        if (!res.Data.OK) {
          setLoadingSave(false)

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text:
              res.Data.Mensaje === null
                ? 'Ha ocurrido un error al intentar guardar el formulario'
                : res.Data.Mensaje,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Reintentar',
            footer:
              '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }
      })
      .catch((err) => {
        setLoadingSave(false)
        console.log(err)
      })
  }

  const alertSelectedPyme = () => {
    const mensaje =
      'Es necesario ingresar todos los datos de la sección Datos Generales para guardar el formulario '
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Campos sin completar ',
      text: mensaje,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
    })
    setCheckPYME(false)
  }

  const getActualDate = () => {
    const hoy = new Date()
    const meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ]

    const arrayData = []
    const fecha =
      hoy.getDate() + '-' + meses[hoy.getMonth()] + '-' + hoy.getFullYear()
    const minutos = (hoy.getMinutes() < 10 ? '0' : '') + hoy.getMinutes()
    let horas = hoy.getHours()
    const ampm = horas >= 12 ? 'PM' : 'AM'
    horas = horas % 12
    const date = fecha + ' ' + horas + ':' + minutos + ':' + ampm

    arrayData.push(date)
    arrayData.push(fecha)

    return arrayData
  }

  const downloadReport = async () => {
    setLoadingPDF(true)

    const date = await getActualDate()
    await getPreIFIPDF(0, date[0]).then((response) => {
      if (response instanceof Blob) {
        setLoadingPDF(false)
        const blob = URL.createObjectURL(response)
        const link = document.createElement('a')

        const filename = 'Formulario Pre-Elegibilidad'

        link.href = blob
        link.download = filename
        document.body.append(link)
        link.click()
        link.remove()
        setLoadingPDF(false)
      } else {
        setLoadingPDF(false)

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ha ocurrido un error al intentar generar el pdf',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Reintentar',
          footer:
            '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
      }
    })
  }

  return (
    <>
      {!editLoading ? (
        <div
          id="wizard-form"
          style={{
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
          }}
        >
          <div style={{ marginBottom: '48px' }}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
              style={{ marginTop: '18px', marginBottom: '16px' }}
            >
              <Grid item md={12} sm={12} xs={12}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                  }}
                >
                  <label className="formTitle">
                    Formulario Pre-elegibilidad de Inversiones para
                    Financiamiento
                  </label>
                </div>
                <label className="formDescription">
                  Rellene la información requerida para registrar el formulario
                </label>
              </Grid>
            </Grid>
            <Grid
              container
              md={12}
              sm={12}
              spacing={1}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <Grid item>
                <div
                  data-tip
                  data-for="exitPop"
                  onClick={() => cancelForm()}
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>
              </Grid>
              {!loadingSave ? (
                <Grid item>
                  <div
                    onClick={() =>
                      checkPYME ? saveForm() : alertSelectedPyme()
                    }
                    data-tip
                    data-for="savePop"
                    style={{
                      backgroundColor: checkPYME ? '#5cb85c' : 'gray',
                      color: '#fff',
                      width: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                      padding: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    <SaveIcon />
                  </div>
                  <ReactTooltip
                    id="savePop"
                    effect="solid"
                    backgroundColor="#5cb85c"
                  >
                    <span>Guardar Borrador</span>
                  </ReactTooltip>
                </Grid>
              ) : (
                <Grid item>
                  <div
                    data-tip
                    data-for="savePop"
                    style={{
                      backgroundColor: 'gray',
                      color: '#fff',
                      width: '40px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                      padding: '5px',
                    }}
                  >
                    <Box sx={{ display: 'flex' }}>
                      <CircularProgress
                        style={{ color: '#fff', height: '18px', width: '18px' }}
                      />
                    </Box>
                  </div>
                  <ReactTooltip
                    id="savePop"
                    effect="solid"
                    backgroundColor="#5cb85c"
                  >
                    <span>Guardar Borrador</span>
                  </ReactTooltip>
                </Grid>
              )}

              {step === 1 ? (
                <Grid item>
                  <div
                    onClick={() => downloadReport()}
                    data-tip
                    data-for="download"
                  >
                    {/* <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} /> */}

                    <LoadingButton
                      loadingPosition="start"
                      variant="contained"
                      startIcon={
                        <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} />
                      }
                      loading={loadingPDF}
                      style={{
                        backgroundColor: '#5cb85c',
                        color: '#fff',
                        width: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '4px',
                        padding: '5px',
                        cursor: 'pointer',
                      }}
                    ></LoadingButton>
                  </div>
                  <ReactTooltip
                    id="download"
                    effect="solid"
                    backgroundColor="#5cb85c"
                  >
                    <span>Descargar</span>
                  </ReactTooltip>
                </Grid>
              ) : (
                ''
              )}
            </Grid>
          </div>

          <Grid
            container
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '36px' }}
          >
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              className={`${
                step === 1 ? `stepper__title-active` : `stepper__title-inactive`
              }`}
            >
              <label>Datos Generales</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              className={`${
                step === 2 ? `stepper__title-active` : `stepper__title-inactive`
              }`}
            >
              <label>Datos de Ubicación</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              className={`${
                step === 3 ? `stepper__title-active` : `stepper__title-inactive`
              }`}
            >
              <label>Datos de Evaluación</label>
            </Grid>
          </Grid>

          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  width: '80%',
                  height: '80vh',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </div>
            }
          >
            <StepWizard initialStep={1}>
              <GeneralData />
              <LocationData />
              <EvaluationData />
            </StepWizard>
          </Suspense>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}

export default CreateForm
